// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
  },
  competition: {
    list: path(ROOTS_DASHBOARD, '/competition/list'),
    quizDetail: (id) => path(ROOTS_DASHBOARD, `/competition/quiz/${id}`),
    newQuiz: path(ROOTS_DASHBOARD, '/competition/quiz/new'),
    editQuiz: (id) => path(ROOTS_DASHBOARD, `/competition/quiz/${id}/edit`),
  },
  bank: {
    questions: path(ROOTS_DASHBOARD, '/bank/questions'),
    questionDetail: (id) => path(ROOTS_DASHBOARD, `/bank/question/${id}`),
    newQuestion: path(ROOTS_DASHBOARD, '/bank/question/new'),
    editQuestion: (id) => path(ROOTS_DASHBOARD, `/bank/question/${id}/edit`),
  },
  reward: {
    list: path(ROOTS_DASHBOARD, '/reward/list'),
    detail: (id) => path(ROOTS_DASHBOARD, `/reward/${id}`),
    new: path(ROOTS_DASHBOARD, '/reward/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/reward/${id}/edit`),
  },
  users: {
    participants: path(ROOTS_DASHBOARD, '/users/participant/list'),
    participantDetail: (id) => path(ROOTS_DASHBOARD, `/users/participant/${id}`),
    editParticipant: (id) => path(ROOTS_DASHBOARD, `/users/participant/${id}/edit`),
  },
  report: {
    competitions: path(ROOTS_DASHBOARD, '/report/competitions'),
    questions: path(ROOTS_DASHBOARD, '/report/questions'),
    users: path(ROOTS_DASHBOARD, '/report/users'),
  },
  accountant: {
    main: path(ROOTS_DASHBOARD, '/accountant/main'),
    withdrawRequest: path(ROOTS_DASHBOARD, '/accountant/withdraw-request'),
    transactionList: path(ROOTS_DASHBOARD, '/accountant/transaction-list'),
  },
  giveaways: {
    list: path(ROOTS_DASHBOARD, '/giveaways/list'),
  },
  shop: {
    list: path(ROOTS_DASHBOARD, '/shop/list'),
    modify: path(ROOTS_DASHBOARD, '/shop/modify'),
  },
};
